module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": function($event) {
        return _vm.editPack()
      }
    }
  }, [_vm._v("ДОБАВИТЬ ПАКЕТ ПО")]), _vm._v(" "), _c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [(_vm.showForm) ? _c('div', [_c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.pack.title),
      callback: function($$v) {
        _vm.$set(_vm.pack, "title", $$v)
      },
      expression: "pack.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "GrottBjörn ID"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.pack.sourceId),
      callback: function($$v) {
        _vm.$set(_vm.pack, "sourceId", $$v)
      },
      expression: "pack.sourceId"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Состав пакета"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.apps,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Выберите ПО",
      "select-label": "Нажмите Enter чтобы выбрать",
      "label": "title",
      "track-by": "id"
    },
    model: {
      value: (_vm.pack.apps),
      callback: function($$v) {
        _vm.$set(_vm.pack, "apps", $$v)
      },
      expression: "pack.apps"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("ОТМЕНИТЬ")])], 1) : _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.packages), function(pack) {
    return _c('li', {
      staticClass: "box",
      on: {
        "click": function($event) {
          return _vm.editPack(pack.id)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(pack.title))]), _vm._v(" - "), _c('strong', [_vm._v(_vm._s(pack.sourceId))]), _vm._v(" "), _c('button', {
      staticClass: "delete is-pulled-right",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.del(pack.id)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(pack.description))]), _vm._v(" "), _c('ul', _vm._l((pack.items), function(item) {
      return _c('router-link', {
        key: item.id,
        staticClass: "box",
        attrs: {
          "to": {
            name: 'SoftwareItem',
            params: {
              id: item.id
            }
          },
          "tag": "li"
        }
      }, [_c('strong', [_vm._v(_vm._s(item.title))])])
    }), 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b9af00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Software/Package.vue
// module id = 950
// module chunks = 0